export default [
  {
    path: '/emitentes',
    name: 'emitentes',
    component: () => import(/* webpackChunkName: "emitentes" */ '../../views/emitentes/Emitentes')
  },
  {
    path: '/emitentes/cadastro',
    name: 'cadastro-emitente',
    component: () => import(/* webpackChunkName: "cadastro-emitente" */ '../../views/emitentes/CadastroEmitente')
  },
  {
    path: '/emitentes/:id',
    name: 'edicao-emitente',
    component: () => import(/* webpackChunkName: "cadastro-emitente" */ '../../views/emitentes/CadastroEmitente')
  }
]
